import Vue from "vue";

const filters = {
  install(Vue) {
    Vue.prototype.$appFilters = {
      numbers: function (evt) {
        evt = evt ? evt : window.event;
        let expect = evt.target.value.toString() + evt.key.toString();

        if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
    };
  },
};
Vue.use(filters);
